var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShortLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.525 9.167l2.983-2.992L8.333 5l-5 5 5 5 1.175-1.175-2.983-2.992h10.142V9.167z",
    fill: "#707a88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortLeft);
export default __webpack_public_path__ + "static/media/short_left.26cb2e7e9091c57814234c400ae84c06.svg";
export { ForwardRef as ReactComponent };